import {isNotEmpty} from "@/utils/util";

export const requireValidTaxpayer = async function (e) {
  // if (e.column.property === 'replaceTaxpayer') {
  //     if (isNotEmpty(e.row.replaceTaxpayer)) {
  //         let rep = /^[\u4e00-\u9fa5]{2,4}$/;
  //         let replaceTaxpayer = e.row.replaceTaxpayer.trim();
  //         if (!rep.test(replaceTaxpayer)) {
  //             return Promise.reject(new Error("请输入正确的纳税人名称"));
  //         }
  //     } else if (isNotEmpty(e.row.repalceTaxNum)) {
  //         return Promise.reject(new Error("请输入纳税人证件号码"));
  //     }
  // } else
  if (e.column.property === 'repalceTaxNum') {
    if (isNotEmpty(e.row.repalceTaxNum)) {
      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      let repalceTaxNum = e.row.repalceTaxNum.trim();
      if (!_IDRe18.test(repalceTaxNum) && !_IDre15.test(repalceTaxNum)) {
        return Promise.reject(new Error("请输入正确的纳税人证件号码"));
      }
    } else if (isNotEmpty(e.row.replaceTaxpayer)) {
      return Promise.reject(new Error("请输入纳税人名称"));
    }
  }
  return Promise.resolve();
}